export default function PrivacyPolicyData() {
  return (
    <div className="mx-auto max-w-4xl rounded-lg px-6 py-[60px] md:py-[80px] lg:py-[100px]">
      <div className="mb-8">
        <p className="mb-4">
          ProxyMed is committed to protecting your privacy and securing your
          personal health information. This Privacy Policy outlines how we
          collect, use, and protect your data in compliance with the Health
          Insurance Portability and Accountability Act (HIPAA) and other
          applicable U.S. laws.
        </p>
      </div>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">1. Information We Collect</h2>
        <p className="mb-2">We collect:</p>
        <ul className="list-disc space-y-2 pl-8">
          <li>
            Personal Information: Name, date of birth, contact details, and
            account credentials.
          </li>
          <li>
            Medical Information: Health history, symptoms, treatment
            preferences, and prescriptions.
          </li>
          <li>
            Payment Information: Credit/debit card details for billing purposes.
          </li>
          <li>
            Device & Usage Data: IP addresses, browser details, and cookies for
            service optimization.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">
          2. How We Use Your Information
        </h2>
        <p className="mb-2">Your data is used to:</p>
        <ul className="list-disc space-y-2 pl-8">
          <li>
            Provide virtual consultations with licensed medical professionals.
          </li>
          <li>Process payments and send appointment confirmations.</li>
          <li>
            Communicate prescription details, treatment plans, and follow-ups.
          </li>
          <li>Improve ProxyMed services and ensure regulatory compliance.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">
          3. Data Protection & Security
        </h2>
        <ul className="list-disc space-y-2 pl-8">
          <li>
            Encryption: All medical data is encrypted and stored securely.
          </li>
          <li>
            Access Control: Only authorized medical professionals can view your
            records.
          </li>
          <li>
            Regulatory Compliance: ProxyMed adheres to HIPAA and other U.S.
            healthcare regulations.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">4. Sharing of Information</h2>
        <p className="mb-2">We only share data when necessary:</p>
        <ul className="list-disc space-y-2 pl-8">
          <li>
            Encryption: All medical data is encrypted and stored securely.
          </li>
          <li>
            Access Control: Only authorized medical professionals can view your
            records.
          </li>
          <li>
            Regulatory Compliance: ProxyMed adheres to HIPAA and other U.S.
            healthcare regulations.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">5. Patient Rights</h2>
        <p className="mb-2">You have the right to:</p>
        <ul className="list-disc space-y-2 pl-8">
          <li>Access, update, or delete your medical records.</li>
          <li>Opt out of marketing communications.</li>
          <li>Request a copy of your health data.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-bold">Contact Information </h2>
        <p className="mb-2">For privacy-related inquiries, contact us at: </p>
        <ul className="list-disc space-y-2 pl-8">
          <li>Email: appointments@proxymedicine.com </li>
          <li>Phone: +1 (888) 779-9633 </li>
        </ul>
      </section>
    </div>
  );
}
